module.exports = __webpack_public_path__ + "img/dots-wa.86b221df.svg";